import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { GetString } from '../StringResourceManager';
import {
  commandStatusTextMap,
  commandStatusToTypeMap,
  getCommandStatusOptions,
} from '../../utils/textMappings';
import { LogsHistoryDropdownFiltercell } from './LogsHistoryDropdownFiltercell';

export const LogsFilterCell: any = (props: GridCustomFilterCellProps) => (
  <LogsHistoryDropdownFiltercell
    {...props}
    data={getCommandStatusOptions()}
    defaultItem={GetString('SELECT_STATUS')}
    onChangeValueCheckFunc={commandStatusToTypeMap}
    commandStatusTextMap={commandStatusTextMap}
  />
);
